import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import logo from '../assets/LED-Speed-Signs-Logo.png';
import Footer from '../components/Footer';
import API_BASE_URL from '../config';
import { TextField, Button, ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import UAParser from 'ua-parser-js';

const Signin = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [textColor, setTextColor] = useState('red');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const colors = ['red', 'green', 'blue'];
    let colorIndex = 0;

    const intervalId = setInterval(() => {
      colorIndex = (colorIndex + 1) % colors.length;
      setTextColor(colors[colorIndex]);
    }, 500); // Change color every 1 second

    return () => clearInterval(intervalId);
  }, []);

  const [errorMessage, setErrorMessage] = useState('');
    const collectDeviceInfo = async () => {
      const parser = new UAParser();
      const uaResult = parser.getResult();
  
      const info = {
        // User Agent Details
        browser: {
          name: uaResult.browser.name,
          version: uaResult.browser.version,
          major: uaResult.browser.major,
        },
        engine: {
          name: uaResult.engine.name,
          version: uaResult.engine.version,
        },
        os: {
          name: uaResult.os.name,
          version: uaResult.os.version,
        },
  
        // Screen & Display
        screenResolution: `${window.screen.width}x${window.screen.height}`,
  
        // Browser Capabilities
        language: navigator.language,
  
        // Time & Location
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        locale: Intl.DateTimeFormat().resolvedOptions().locale,
      };
  
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        if (ipResponse.ok) {
          const ipData = await ipResponse.json();
          info.ipAddress = ipData.ip;
        }
      } catch (e) {
        console.warn('Could not fetch IP:', e);
      }
  
      // Get IP and geolocation via free API (ipapi.co)
      try {
        const getBrowserLocation = () => {
          return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
              reject(new Error('Geolocation not supported'));
              return;
            }
            
            navigator.geolocation.getCurrentPosition(
              (position) => {
                resolve({
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                  accuracy: position.coords.accuracy, // meters
                  altitude: position.coords.altitude,
                  altitudeAccuracy: position.coords.altitudeAccuracy,
                  heading: position.coords.heading,
                  speed: position.coords.speed,
                  timestamp: position.timestamp
                });
              },
              (error) => {
                reject(error);
              },
              {
                enableHighAccuracy: true, // Use GPS if available
                timeout: 10000,
                maximumAge: 0
              }
            );
          });
        };
        if (navigator.geolocation) {
          const geoData = await getBrowserLocation();
          info.location = {
            city: geoData.city,
            region: geoData.region,
            regionCode: geoData.region_code,
            country: geoData.country_name,
            latitude: geoData.latitude,
            longitude: geoData.longitude,
            timezone: geoData.timezone,
            languages: geoData.languages,
            asn: geoData.asn,
            org: geoData.org,
          };
        }
      } catch (e) {
        console.warn('IP geolocation failed:', e);
      }
  
      // Additional browser features detection
      info.features = {
        localStorage: !!window.localStorage,
        sessionStorage: !!window.sessionStorage,
        indexedDB: !!window.indexedDB,
        serviceWorker: 'serviceWorker' in navigator,
        webGL: (() => {
          try {
            const canvas = document.createElement('canvas');
            return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
          } catch {
            return false;
          }
        })(),
        webRTC: !!(window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection),
        webSocket: 'WebSocket' in window,
        webAudio: 'AudioContext' in window || 'webkitAudioContext' in window,
      };
  
      // Connection info (if available)
      if (navigator.connection) {
        info.connection = {
          effectiveType: navigator.connection.effectiveType,
          downlink: navigator.connection.downlink,
          rtt: navigator.connection.rtt,
          saveData: navigator.connection.saveData,
        };
      }
  
      return info;
    };
  
    const handleLogin = async (e) => {
      setLoading(true);

      e.preventDefault();
      setErrorMessage('');

      const deviceInfo = await collectDeviceInfo();
  
      try {
        const response = await fetch(`${API_BASE_URL}/users/data-signin`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id, password, deviceInfo }),
        });
  
        if (response.status === 400) {
          setErrorMessage('User not found. Please check your ID and password.');
          return;
        } else if (response.status === 401) {
          setErrorMessage('Invalid credentials. Please try again.');
          return;
        } else if (response.status === 418) {
          setErrorMessage('User is inactive. Please contact your administrator.');
          return;
        } else if (response.status === 423) {
          setErrorMessage('Subscription suspended. Please contact your administrator.');
          return;
        }
  
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const data = await response.json();
        
        if (response.ok) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('primaryColor', data.primaryColor || '#0f0f0f');
            localStorage.setItem('secondaryColor', data.secondaryColor || '#1a1a1a');
            localStorage.setItem('darkMode', true);
            navigate('/data/dashboard');
          } else {
            console.error('Error signing in:', data.message);
          }
      } catch (error) {
        console.error('Error:', error);
        setErrorMessage('An error occurred. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

  const handleBack = () => {
    navigate('/landing');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      margin: 0,
      padding: 0,
      overflow: 'hidden'
    }}>
      {/* Data login form above the fox */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#ececec',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        width: '400px',
        maxWidth: '90%',
        zIndex: 10
      }}>
        <img src={logo} alt="IMS Logo" className="logo" />
        {/* Add clear Data Portal header to differentiate this page */}
        <h2 style={{ 
          margin: '15px 0 25px 0', 
          color: '#1976d2', 
          fontSize: '22px', 
          fontWeight: 'bold',
          borderBottom: '2px solid #1976d2',
          paddingBottom: '15px'
        }}>
          Data Portal
        </h2>
        <form className="login-form" onSubmit={handleLogin}>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div className="input-group">
            <TextField
              fullWidth
              label="ID"
              variant="outlined"
              type="id"
              value={id}
              onChange={(e) => setId(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <TextField
              fullWidth
              label="Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            fullWidth 
            className="btn"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'SIGN IN'
            )}
          </Button>
        </form>

        <Button 
          onClick={handleBack} 
          variant="outlined"
          color="primary"
          style={{ marginTop: '10px' }}
          fullWidth
        >
          Back
        </Button>
        {errorMessage && (
            <p style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default Signin;